var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandMoreItems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3805 21.4L15.3805 12.0484L12.0574 15.2668C11.8155 15.5011 11.4232 15.5011 11.1814 15.2669C10.9395 15.0326 10.9395 14.6526 11.1814 14.4183L15.562 10.1758C15.5908 10.1479 15.6226 10.123 15.6563 10.1011C15.672 10.0911 15.6888 10.084 15.7051 10.0753C15.7243 10.0654 15.7426 10.054 15.7629 10.046C15.7838 10.0375 15.8055 10.0327 15.8271 10.0267C15.8443 10.0218 15.8608 10.0153 15.8784 10.0119C15.9187 10.0041 15.9593 10 16 10L16.0014 10.0001C16.0415 10.0003 16.0818 10.0042 16.1213 10.0119C16.1398 10.0155 16.157 10.0222 16.1753 10.0274C16.1959 10.0333 16.2168 10.0378 16.2368 10.0459C16.2583 10.0546 16.2778 10.0663 16.2981 10.0771C16.3133 10.0852 16.3288 10.0916 16.3434 10.1009C16.3776 10.1228 16.4095 10.148 16.4384 10.1761L20.8185 14.4184C21.0605 14.6527 21.0605 15.0326 20.8187 15.2669C20.5768 15.5012 20.1845 15.5012 19.9424 15.2669L16.6195 12.0485V21.4C16.6195 21.7314 16.3421 22 16 22C15.6579 22 15.3805 21.7314 15.3805 21.4Z",
    fill: "#004FC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMoreItems);
export default __webpack_public_path__ + "static/media/expand-more-items.5f8ee023e4bf36e50038331bc96a41a1.svg";
export { ForwardRef as ReactComponent };